import { render, staticRenderFns } from "./LessonContentSubject.vue?vue&type=template&id=03b4a9b4&scoped=true"
import script from "./LessonContentSubject.vue?vue&type=script&lang=js"
export * from "./LessonContentSubject.vue?vue&type=script&lang=js"
import style0 from "./LessonContentSubject.vue?vue&type=style&index=0&id=03b4a9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b4a9b4",
  null
  
)

export default component.exports